import { graphql } from '../gql';
import { useSubscription } from '@apollo/client';

export const GET_SUBMISSIONS_EVENTS = graphql(`
  subscription Events {
    events(
      filters: { heartbeatDuration: 300, eventFilters: [{ name: SUBMISSION }] }
    ) {
      ... on SubscriptionEventModel {
        eventName
        eventUuid
        eventStatus
        eventNotice {
          noticeType
          noticeArea
          noticeTask
          noticeName
          noticeValue
          noticeDagId
        }
      }
      ... on SubscriptionHeartbeat {
        subscriptionUuid
        queueId
        timestamp
      }
    }
  }
`);

export function useSubmissionsSubscriptionQuery() {
  const { data, error } = useSubscription(GET_SUBMISSIONS_EVENTS);
  const submissionsStatus =
    data &&
    data.events.__typename === 'SubscriptionEventModel' &&
    data.events.eventStatus;

  const submissionsEventNotice =
    data &&
    data.events.__typename === 'SubscriptionEventModel' &&
    data.events.eventNotice?.noticeArea === 'Underwriting Rules' &&
    data.events.eventNotice?.noticeName === 'status' &&
    (data.events.eventNotice?.noticeValue === 'completed' ||
      data.events.eventNotice?.noticeValue === 'pending');

  return {
    data,
    error,
    submissionsStatus,
    submissionsEventNotice,
  };
}
